import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import AzureSVG from '../../../assets/icons/clouds/azure.svg?raw';

export const AzureLogo = (props) => <CustomSVG svg={AzureSVG} preserveColors {...props} />;
